import api from "services/api";
import { API_URL_VERSION } from "constants/environment";
import { toSearchFilter } from "utils/utils";

export const ENDPOINT_TRAFFIC_VIOLATIONS = API_URL_VERSION + "infracoes";
export const ENDPOINT_TRAFFIC_VIOLATIONS_LIST = ENDPOINT_TRAFFIC_VIOLATIONS + "/lista";
export const ENDPOINT_TRAFFIC_VIOLATIONS_SAVE = ENDPOINT_TRAFFIC_VIOLATIONS + "/salvar";
export const ENDPOINT_TRAFFIC_VIOLATIONS_VALIDATE = ENDPOINT_TRAFFIC_VIOLATIONS + "/validar";
export const ENDPOINT_TRAFFIC_VIOLATIONS_CANCEL = ENDPOINT_TRAFFIC_VIOLATIONS + "/cancelar";
export const ENDPOINT_TRAFFIC_VIOLATIONS_DEFER = ENDPOINT_TRAFFIC_VIOLATIONS + "/deferir";
export const ENDPOINT_TRAFFIC_VIOLATIONS_PRINT_AIT = ENDPOINT_TRAFFIC_VIOLATIONS + "/imprimir-ait-pdf";
export const ENDPOINT_TRAFFIC_VIOLATIONS_PRINT_NA = ENDPOINT_TRAFFIC_VIOLATIONS + "/imprimir-na-pdf";
export const ENDPOINT_TRAFFIC_VIOLATIONS_PRINT_NP = ENDPOINT_TRAFFIC_VIOLATIONS + "/imprimir-np-pdf";
export const ENDPOINT_TRAFFIC_VIOLATIONS_DETAILS = ENDPOINT_TRAFFIC_VIOLATIONS + "/detalhes";
export const ENDPOINT_TRAFFIC_VIOLATIONS_INFORM_DRIVER = ENDPOINT_TRAFFIC_VIOLATIONS + "/inform-driver";
export const ENDPOINT_TRAFFIC_VIOLATIONS_UNDO_DEFER = ENDPOINT_TRAFFIC_VIOLATIONS + "/desfazer-deferimento";
export const ENDPOINT_TRAFFIC_VIOLATIONS_UNDO_CANCEL = ENDPOINT_TRAFFIC_VIOLATIONS + "/desfazer-cancelamento";
export const ENDPOINT_TRAFFIC_VIOLATION_DUPLICATE = ENDPOINT_TRAFFIC_VIOLATIONS + "/duplicadas"
export const ENDPOINT_TRAFFIC_VIOLATION_QUERY_HISTORY = ENDPOINT_TRAFFIC_VIOLATIONS + "/consultahistorico"
export const ENDPOINT_TRAFFIC_VIOLATION_CONFIRM_PAYMENT = ENDPOINT_TRAFFIC_VIOLATIONS + "/confirmar-pagamento"
export const ENDPOINT_TRAFFIC_VIOLATION_IMAGE = "/imagem";
export const ENDPOINT_TRAFFIC_VIOLATIONS_ESPELHO = ENDPOINT_TRAFFIC_VIOLATIONS;

export const ViolationStatus = {
  NOT_VALIDATED: { value: "NAO_VALIDADA", labelKey: "not-validated" },
  VALIDATED: { value: "VALIDADA", labelKey: "validated" },
  CANCELED: { value: "CANCELADA", labelKey: "canceled" },
  DIVERGENT: { value: "DIVERGENTE", labelKey: "divergent" },
  AGENT_ERROR: { value: "ERRO_AGENTE", labelKey: "agent-error" },
  OTHERS: { value: "OUTROS", labelKey: "others" },
  WARNING: { value: "ADVERTENCIA", labelKey: "warning" },
  OTHER_STATES: { value: "OUTROS_ESTADOS", labelKey: "other-states" },
  NOT_REGISTERED: { value: "NAO_CADASTRADA", labelKey: "not-registered" },
  UNREADABLE: { value: "ILEGIVEL", labelKey: "unreadable" },
  DUPLICATED: { value: "DUPLICADA", labelKey: "duplicated" },
  ERROR_REG_EQUIP: { value: "ERRO_REG_EQUIPAMENTO", labelKey: "error-reg-equip" },
  VEHICLE_EMERGENCY: { value: "VEICULO_EMERGENCIA_URGENCIA", labelKey: "vehicle-emergency" },
}

export const ViolationSituation = {
  NOT_VALIDATED: { value: "NAO_VALIDADA", labelKey: "not-validated" },
  VALIDATED: { value: "VALIDADA", labelKey: "validated" },
  CANCELED: { value: "CANCELADA", labelKey: "canceled" },
  DIVERGENT: { value: "DIVERGENTE", labelKey: "divergent" },
  AGENT_ERROR: { value: "ERRO_AGENTE", labelKey: "agent-error" },
  OTHERS: { value: "OUTROS", labelKey: "others" },
  WARNING: { value: "ADVERTENCIA", labelKey: "warning" },
  OTHER_STATES: { value: "OUTROS_ESTADOS", labelKey: "other-states" },
  NOT_REGISTERED: { value: "NAO_CADASTRADA", labelKey: "not-registered" },
  UNREADABLE: { value: "ILEGIVEL", labelKey: "unreadable" },
  DUPLICATED: { value: "DUPLICADA", labelKey: "duplicated" },
  ERROR_REG_EQUIP: { value: "ERRO_REG_EQUIPAMENTO", labelKey: "error-reg-equip" },
  VEHICLE_EMERGENCY: { value: "VEICULO_EMERGENCIA_URGENCIA", labelKey: "vehicle-emergency" },
  DEFERRED: { value: "DEFERIDA", labelKey: "deferred" },
  NP_GENERATED: { value: "NP_GERADA", labelKey: "np-generated" },
  NA_GENERATED: { value: "NA_GERADA", labelKey: "na-generated" },
}

export const trafficViolationService = {
  findMany: async (params) => {
    try {
      const searchParams = toSearchFilter(params);
      const response = await api.get(ENDPOINT_TRAFFIC_VIOLATIONS, { params: searchParams });
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "traffic-violation.messages.errors.list";
    }
  },

  list: async (params = {}) => {
    try {
      const searchParams = toSearchFilter(params);
      const response = await api.post(ENDPOINT_TRAFFIC_VIOLATIONS_LIST, searchParams);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "traffic-violation.messages.errors.list";
    }
  },

  create: async (data) => {
    try {
      const response = await api.post(ENDPOINT_TRAFFIC_VIOLATIONS_SAVE, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || error.response?.data?.erros_validacao || "traffic-violation.messages.errors.create";
    }
  },

  find: async (id) => {
    try {
      const response = await api.get(`${ENDPOINT_TRAFFIC_VIOLATIONS}/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "traffic-violation.messages.errors.find";
    }
  },

  update: async (id, data) => {
    try {
      const response = await api.put(`${ENDPOINT_TRAFFIC_VIOLATIONS}/${id}`, data);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || error.response?.data?.erros_validacao || "traffic-violation.messages.errors.update";
    }
  },

  validate: async (id, data) => {
    try {
      const response = await api.post(`${ENDPOINT_TRAFFIC_VIOLATIONS_VALIDATE}/${id}`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    } catch (error) {
      const defaultError = data.status === ViolationStatus.VALIDATED ? "traffic-violation.messages.errors.validate" : "traffic-violation.messages.errors.invalidate";
      throw error.response?.data?.message || error.response?.data?.erros_validacao || defaultError;
    }
  },

  findByAITNumber: async (numero_ait) => {
    try {
      const response = await api.get(`${ENDPOINT_TRAFFIC_VIOLATIONS}?numero_ait=${numero_ait}`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "traffic-violation.messages.errors.find";
    }
  },

  cancel: async (id, data) => {
    try {
      const response = await api.post(`${ENDPOINT_TRAFFIC_VIOLATIONS_CANCEL}/${id}`, data);
      return response.data;
    } catch (error) {
      throw error.response?.data?.erros_validacao || "traffic-violation.messages.errors.cancel";
    }
  },

  defer: async (id, data) => {
    try {
      const response = await api.post(`${ENDPOINT_TRAFFIC_VIOLATIONS_DEFER}/${id}`, data);
      return response.data;
    } catch (error) {
      throw error.response?.data?.erros_validacao || "traffic-violation.messages.errors.defer";
    }
  },

  printAit: async (id) => {
    try {
      const response = await api.get(`${ENDPOINT_TRAFFIC_VIOLATIONS_PRINT_AIT}/${id}`, {
        responseType: 'blob'
      });
      return response;
    } catch (error) {
      throw error.response?.data?.message || error.response?.data?.erros_validacao || "traffic-violation.messages.errors.print-ait";
    }
  },

  printNa: async (id) => {
    try {
      const response = await api.get(`${ENDPOINT_TRAFFIC_VIOLATIONS_PRINT_NA}/${id}`, {
        responseType: 'blob'
      });
      return response;
    } catch (error) {
      throw error.response?.data?.message || "traffic-violation.messages.errors.print-na";
    }
  },

  printNp: async (id) => {
    try {
      const response = await api.get(`${ENDPOINT_TRAFFIC_VIOLATIONS_PRINT_NP}/${id}`, {
        responseType: 'blob'
      });
      return response;
    } catch (error) {
      throw error.response?.data?.message || "traffic-violation.messages.errors.print-np";
    }
  },

  details: async (id) => {
    try {
      const response = await api.get(`${ENDPOINT_TRAFFIC_VIOLATIONS_DETAILS}/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || error.response?.data?.erros_validacao || "traffic-violation.messages.errors.find";
    }
  },

  espelho: async (id) => {
    try {
      const response = await api.get(`${ENDPOINT_TRAFFIC_VIOLATIONS_ESPELHO}/${id}/espelho`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || error.response?.data?.erros_validacao || "traffic-violation.messages.errors.find";
    }
  },

  queryTrafficViolationHistory: async (numeroControleDetran) => {
    try {
      const response = await api.get(`${ENDPOINT_TRAFFIC_VIOLATION_QUERY_HISTORY}/${numeroControleDetran}`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || error.response?.data?.erros_validacao || "traffic-violation.messages.errors.find";
    }
  },

  updateDriver: async (id, data) => {
    try {
      const response = await api.put(`${ENDPOINT_TRAFFIC_VIOLATIONS_INFORM_DRIVER}/${id}`, data);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || error.response?.data?.erros_validacao || "traffic-violation.messages.errors.inform-driver";
    }
  },

  undoDefer: async (id) => {
    try {
      const response = await api.put(`${ENDPOINT_TRAFFIC_VIOLATIONS_UNDO_DEFER}/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || error.response?.data?.erros_validacao || "traffic-violation.messages.errors.undo-defer";
    }
  },

  undoCancel: async (id) => {
    try {
      const response = await api.put(`${ENDPOINT_TRAFFIC_VIOLATIONS_UNDO_CANCEL}/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || error.response?.data?.erros_validacao || "traffic-violation.messages.errors.undo-cancel";
    }
  },
  
  getImage: async (id, fileName) => {
    try {
      const response = await api.get(
        `${ENDPOINT_TRAFFIC_VIOLATIONS}/${id}${ENDPOINT_TRAFFIC_VIOLATION_IMAGE}/${fileName}`,
        { responseType: "blob" }
      );

      return URL.createObjectURL(response.data);
    } catch (error) {
      throw (
        error.response?.data?.message || "traffic-violation.messages.errors.image"
      );
    }
  },
  checkDuplicate: async (id) => {
    try {
      const response = await api.get(`${ENDPOINT_TRAFFIC_VIOLATION_DUPLICATE}/${id}`);
      return response.data;
    } catch (error) {
      throw (
        error.response?.data?.message || "traffic-violation.messages.errors.find"
      );
    }
  },
  confirmPayment: async (id, data) => {
    try {
      const response = await api.post(`${ENDPOINT_TRAFFIC_VIOLATION_CONFIRM_PAYMENT}/${id}`, data);
      return response.data;
    } catch (error) {
      throw error.response?.data?.erros_validacao || "traffic-violation.messages.errors.find";
    }
  },
  confirmPaymentCnab: async (data) => {
    try {
      const response = await api.post(`${ENDPOINT_TRAFFIC_VIOLATION_CONFIRM_PAYMENT}`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        }
      });
      return response.data;
    } catch (error) {
      throw error.response?.data?.erros_validacao || "traffic-violation.messages.errors.upload-file";
    }
  }
};
